// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-35c8f644]:export {\n  menuBg: #304156;\n  menuText: #bfcbd9;\n  menuActiveText: #409EFF;\n}\n\n/* Mixins */\n.filter-container[data-v-35c8f644] {\n  margin-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
